import * as request from '@eika-infrastruktur/request';
import { DefaultHttpClient } from './default-http-client';
import DefaultRestApplicationClient from './default-rest-application-client';
export default new DefaultRestApplicationClient(new DefaultHttpClient(request));